import React from 'react';
import { FaBriefcase, FaUsersCog, FaLaptopCode, FaChartBar, FaFolderOpen, FaNetworkWired, FaBullseye, FaFileAlt, FaHandshake } from 'react-icons/fa';

const AboutSection = ({ expanded = false }) => {
  return (
    <section className={`py-20 ${expanded ? 'bg-white' : 'bg-gray-50'}`}>
      <div className="container mx-auto px-6">
        {/* Quiénes Somos */}
        <div className="flex flex-col lg:flex-row items-center mb-16">
          <div className="lg:w-2/3 mb-12 lg:mb-0 lg:pr-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#007dc6] mb-6">
              ¿Quiénes somos?
            </h2>
            <p className="text-gray-700 mb-4">
              Steps Colombia SAS es una empresa fundada en el año 2018 dedicada al desarrollo y servicio de
              plataformas con base web, así como soluciones a pequeñas y medianas empresas para implementación dentro y fuera de Colombia.
            </p>
            <p className="text-gray-700 mb-4">
              Manejamos el servicio de las plataformas con la libertad de poder realizar adaptaciones para su
              implementación y operación ya que son diseñadas al 100 % por nosotros.
            </p>
            <p className="text-gray-700">
              Junto con nuestro equipo de profesionales altamente calificados en diferentes áreas tecnológicas, operacionales
              y de servicio hemos completado proyectos exitosos para clientes en diversos sectores económicos.
            </p>
          </div>
          <div className="lg:w-1/3 grid grid-cols-3 gap-4 text-[#007dc6] text-4xl justify-items-center">
            <FaBriefcase />
            <FaUsersCog />
            <FaLaptopCode />
            <FaChartBar />
            <FaFolderOpen />
            <FaNetworkWired />
            <FaBullseye />
            <FaFileAlt />
            <FaHandshake />
          </div>
        </div>

        {/* Misión */}
        <div className="relative bg-[#007dc6] text-white rounded-xl shadow-lg mb-12 overflow-hidden hover:bg-white group transition duration-300">
          <div className="flex flex-col lg:flex-row justify-between items-center px-6 py-8">
            <div className="lg:w-3/4 text-left group-hover:text-black transition duration-300">
              <h3 className="text-2xl font-bold mb-2">Misión</h3>
              <p className="text-lg">
                Brindar soluciones digitales innovadoras que impulsen el crecimiento de nuestros clientes,
                generando impacto positivo en la sociedad.
              </p>
            </div>
            <div className="lg:w-1/4 mt-6 lg:mt-0 flex justify-center relative">
              <div className="w-72 h-44 rounded-lg border-4 border-white overflow-hidden">
                <img
                  src="/img/mision.jpg"
                  alt="Misión"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Visión */}
        <div className="relative bg-[#007dc6] text-white rounded-xl shadow-lg mb-12 overflow-hidden hover:bg-white group transition duration-300">
          <div className="flex flex-col lg:flex-row-reverse justify-between items-center px-6 py-8">
            <div className="lg:w-3/4 text-left group-hover:text-black transition duration-300">
              <h3 className="text-2xl font-bold mb-2">Visión</h3>
              <p className="text-lg">
                Ser referentes en el desarrollo tecnológico en Latinoamérica, destacándonos por nuestro compromiso,
                calidad y transformación digital.
              </p>
            </div>
            <div className="lg:w-1/4 mt-6 lg:mt-0 flex justify-center relative">
              <div className="w-72 h-44 rounded-lg border-4 border-white overflow-hidden">
                <img
                  src="/img/vision.jpg"
                  alt="Visión"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Valores */}
        <h3 className="text-3xl font-bold text-[#007dc6] mb-10 text-center">Nuestros Valores</h3>
        <div className="grid md:grid-cols-2 gap-8">
          {[{
              numero: '1',
              titulo: 'Cumplimiento',
              descripcion: 'Con el Estado, nuestra gente, nuestros clientes y afiliados.'
            },{
              numero: '2',
              titulo: 'Pasión',
              descripcion: 'El entusiasmo con el que vivimos y hacemos lo que nos corresponde.'
            },{
              numero: '3',
              titulo: 'Respeto',
              descripcion: 'Al anciano, al niño, al joven y a quien piensa diferente.'
            },{
              numero: '4',
              titulo: 'Inclusión',
              descripcion: 'Espacio para todos. Cero tolerancias con la discriminación.'
            },{
              numero: '5',
              titulo: 'Ser Facilitador',
              descripcion: 'Facilitadores de instrumentos, herramientas y oportunidades.'
            },{
              numero: '6',
              titulo: 'Responsabilidad Social',
              descripcion: 'Comprometidos con la gente y la comunidad como ciudadano corporativo.'
          }].map((valor, index) => (
            <div key={index} className="flex shadow-md rounded-lg overflow-hidden bg-white">
              <div className="bg-[#007dc6] text-white text-3xl font-bold flex items-center justify-center w-16 p-4">
                {valor.numero}
              </div>
              <div className="p-4">
                <h4 className="text-xl font-semibold text-[#007dc6]">{valor.titulo}</h4>
                <p className="text-gray-600">{valor.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;